import { decodeCallData, selectUserOpsByAddress, userOpsStore } from '@towns/userops'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { Address } from 'viem'

export function useDecodedCallData(address?: Address) {
    const myAbstractAccountAddress = useMyAbstractAccountAddress().data
    const _address = address ?? myAbstractAccountAddress
    return useDecodedCallDataWithAddress(_address)
}

export function useDecodedCallDataWithAddress(address: Address | undefined) {
    const current = userOpsStore((s) => selectUserOpsByAddress(address, s)?.current)

    const currOpDecodedCallData =
        current?.op?.callData && current.functionHashForPaymasterProxy
            ? decodeCallData({
                  callData: current.op.callData,
                  functionHash: current.functionHashForPaymasterProxy,
              })
            : undefined

    return currOpDecodedCallData
}
